<template>
    <div class="dvBgiBox">
        <div style="height: 40px;">
            <p style="font-size: 22px;font-weight: 600;text-align: right;color: #fff;">{{ $t('grid.title') }}</p>
        </div>

        <div class="right01">
            <div style="display: flex;justify-content: space-between;height: 100%;align-items: center;">
                <div class="colim01">
                    <div class="item">
                        <div
                            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                            <span class="txt1">{{ $t('grid.voltage') }}</span>
                            <img src="../../assets/current.png" style="width: 26px;height: 26px;" alt="">
                        </div>

                        <div class="txt2">
                            <span>{{ mains.ac_dcVol }}</span>
                            <span style="font-size: 20px;margin-left: 3px;">v</span>
                        </div>
                    </div>

                    <div class="item">
                        <div
                            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                            <span class="txt1">{{ $t('grid.current') }}</span>
                            <img src="../../assets/ADvoltage.png" style="width: 25px;height: 25px;" alt="">
                        </div>

                        <div class="txt2">
                            <span>{{ mains.ac_dcCol }}</span>
                            <span style="font-size: 20px;margin-left: 3px;">A</span>
                        </div>
                    </div>
                </div>

                <div class="colimCC">
                    <span style="font-size: 16px;color: #01aced;">{{ $t('common.frequency') }}</span>
                    <span style="font-weight: 600;font-size: 24px;">50HZ</span>
                </div>

                <div class="colim01">
                    <div class="item">
                        <div
                            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                            <img src="../../assets/brightnessPower.png" style="width: 28px;height: 28px;" alt="">
                            <span class="txt1">{{ $t('grid.totalPower') }}</span>
                        </div>

                        <div class="txt2">
                            <span>{{ mains.dischargePower }}</span>
                            <span style="font-size: 22px;margin-left: 3px;">KWh</span>
                        </div>
                    </div>

                    <div class="item">
                        <div
                            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
                            <img src="../../assets/GroupNum.png" style="width: 28px;height: 28px;" alt="">
                            <span class="txt1">{{ $t('cumulative.gridConsumption') }}</span>
                        </div>

                        <div class="txt2">
                            <span>{{ mains.totalEcele_day }}</span>
                            <span style="font-size: 22px;margin-left: 3px;">kWh</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    props: {
        mains: {
            default: {}
        }
    },
    watch: {

    },

    methods: {


    }

}
</script>

<style scoped>
.dvBgiBox {
    width: 100%;
    height: 300px;
    padding: 5px 10px 10px 10px;
    background-image: url("../../assets/dvBgiBoxRight.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.txt1 {
    color: #56fefe;
}

.txt2 {
    font-size: 19px;
    font-weight: 600;
    margin-top: 10px;
}

.right01 {
    width: 95%;
    height: 75%;
    background-image: url("../../assets/right03-1.png");
    background-size: 100% 100%;
    margin: auto;
    margin-top: 20px;
}

.colim01 {
    width: 26%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 20px 15px 20px;
}

.colimCC {
    width: 30%;
    height: 67%;
    background-image: url("../../assets/right01-7.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border-radius: 50%;
}
.colimCC:hover {
    transform: scale(1.2);
    box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
}

.item {
    width: 100%;
    display: flex;
    flex-direction: column;
    /* padding: 20px; */
}
</style>